// submitOnLoad
ht.declare('form.submitOnLoad', function () {
  $(this).trigger('submit');
});
